import React, { useEffect } from 'react';

const Consultation = () => {
  // Load Razorpay script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    document.body.appendChild(script);
    
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleBookConsultation = (planTitle) => {
    const options = {
      key: 'rzp_live_RLYU1Sy6Ny1A6S', // Your Razorpay key
      amount: 99900, // Amount in paise (₹999 = 99900 paise)
      currency: 'INR',
      name: 'HeyGerman',
      description: planTitle,
      image: `${process.env.PUBLIC_URL}/icon.png`,
      handler: function (response) {
        console.log('Payment successful:', response);
        alert(`🎉 Payment successful!\n\nPayment ID: ${response.razorpay_payment_id}\n\nThank you for booking your consultation. We will contact you shortly to schedule your session.`);
        // You can add additional success handling here
        // For example, redirect to a success page or send data to your backend
      },
      prefill: {
        name: localStorage.getItem('userName') || '',
        email: localStorage.getItem('userEmail') || '',
        contact: ''
      },
      notes: {
        consultation_type: planTitle
      },
      theme: {
        color: '#667eea'
      },
      modal: {
        ondismiss: function() {
          console.log('Payment modal closed');
        }
      }
    };

    if (window.Razorpay) {
      const rzp = new window.Razorpay(options);
      rzp.on('payment.failed', function (response) {
        console.log('Payment failed:', response.error);
        alert(`Payment failed: ${response.error.description}`);
      });
      rzp.open();
    } else {
      alert('Payment system is loading. Please try again in a moment.');
    }
  };

  const plans = [
    {
      id: 1,
      title: "Visa & Immigration Consultation",
      price: "₹999",
      duration: "60 minutes",
      popular: false,
      features: [
        "German Student Visa Application Guidance",
        "Document Preparation Checklist",
        "Interview Preparation Tips",
        "Visa Requirements Overview",
        "Embassy Appointment Assistance",
        "Visa Rejection Appeal Support",
        "Financial Documentation Help",
        "Follow-up Support (30 days)"
      ]
    },
    {
      id: 2,
      title: "University Admission Consultation",
      price: "₹999",
      duration: "90 minutes",
      popular: true,
      features: [
        "University Selection Strategy",
        "Application Process Walkthrough",
        "Statement of Purpose Review",
        "Letter of Recommendation Guidance",
        "Course Selection Advice",
        "Scholarship Opportunities",
        "Application Timeline Planning",
        "Admission Requirements Analysis",
        "University Ranking Insights",
        "Follow-up Support (60 days)"
      ]
    },
    {
      id: 3,
      title: "Complete Student Package",
      price: "₹999",
      duration: "3 sessions",
      popular: false,
      features: [
        "Everything in Visa Consultation",
        "Everything in University Consultation",
        "Accommodation Finding Assistance",
        "Bank Account Opening Guidance",
        "Health Insurance Advisory",
        "Job Search Strategies",
        "Cultural Integration Tips",
        "Language Learning Resources",
        "Networking Opportunities",
        "Monthly Check-ins (6 months)",
        "Emergency Support Hotline",
        "Pre-arrival Checklist"
      ]
    },
    {
      id: 4,
      title: "Career Guidance Consultation",
      price: "₹999",
      duration: "45 minutes",
      popular: false,
      features: [
        "Career Path Planning in Germany",
        "Resume/CV Optimization",
        "Job Market Analysis",
        "Interview Preparation",
        "Professional Networking Tips",
        "Industry-specific Guidance",
        "Salary Negotiation Strategies",
        "Work Permit Information",
        "Professional Development Plan"
      ]
    },
    {
      id: 5,
      title: "Language Learning Strategy",
      price: "₹999",
      duration: "45 minutes",
      popular: false,
      features: [
        "Personalized Learning Plan",
        "Study Material Recommendations",
        "Progress Tracking Methods",
        "Speaking Practice Techniques",
        "Grammar Mastery Strategies",
        "Exam Preparation (TestDaF, DSH)",
        "Language Exchange Opportunities",
        "Cultural Context Learning",
        "Motivation Techniques"
      ]
    },
    {
      id: 6,
      title: "Emergency Support Session",
      price: "₹999",
      duration: "30 minutes",
      popular: false,
      features: [
        "Urgent Problem Resolution",
        "Crisis Management Support",
        "Last-minute Application Help",
        "Document Emergency Assistance",
        "Immediate Guidance",
        "Priority Scheduling",
        "Same-day Response",
        "Quick Solution Strategies"
      ]
    }
  ];

  return (
    <div className="page">
      <style jsx>{`
        @media (max-width: 768px) {
          .consultation-header h1 {
            font-size: 2.2rem !important;
            line-height: 1.2 !important;
            margin-bottom: 15px !important;
          }
          
          .consultation-header p {
            font-size: 1rem !important;
            padding: 0 20px !important;
          }
          
          .plans-grid {
            grid-template-columns: 1fr !important;
            gap: 20px !important;
            padding: 0 20px !important;
          }
          
          .plan-card {
            padding: 30px 20px !important;
          }
          
          .plan-title {
            font-size: 1.3rem !important;
            line-height: 1.3 !important;
          }
          
          .plan-price {
            font-size: 2rem !important;
          }
          
          .plan-features {
            margin-bottom: 25px !important;
          }
          
          .plan-feature {
            font-size: 0.9rem !important;
            margin-bottom: 10px !important;
          }
          
          .why-choose-grid {
            grid-template-columns: 1fr !important;
            gap: 30px !important;
            padding: 0 20px !important;
          }
          
          .why-choose-title {
            font-size: 2rem !important;
            line-height: 1.2 !important;
          }
          
          .cta-section h2 {
            font-size: 1.8rem !important;
            line-height: 1.2 !important;
          }
          
          .cta-section p {
            font-size: 1rem !important;
            padding: 0 20px !important;
          }
        }
        
        @media (max-width: 480px) {
          .consultation-header {
            padding: 60px 0 40px 0 !important;
          }
          
          .consultation-header h1 {
            font-size: 1.9rem !important;
          }
          
          .plans-section {
            padding: 60px 0 !important;
          }
          
          .why-choose-section {
            padding: 60px 0 !important;
          }
          
          .cta-section {
            padding: 50px 0 !important;
          }
          
          .why-choose-grid {
            grid-template-columns: 1fr !important;
            gap: 30px !important;
          }
          
          .why-choose-title {
            font-size: 1.8rem !important;
          }
          
          .feature-card {
            padding: 20px !important;
            margin-bottom: 20px;
          }
          
          .feature-title {
            font-size: 1.2rem !important;
          }
          
          .feature-text {
            font-size: 0.9rem !important;
          }
          
          .cta-section {
            padding: 40px 0 !important;
          }
          
          .cta-section h2 {
            font-size: 1.6rem !important;
          }
          
          .cta-section p {
            font-size: 1rem !important;
          }
        }
        
        @media (max-width: 480px) {
          .consultation-header h1 {
            font-size: 2rem !important;
          }
          
          .consultation-header p {
            font-size: 1rem !important;
          }
          
          .container {
            padding: 0 15px !important;
          }
          
          .plan-card {
            padding: 20px 15px !important;
            margin-bottom: 20px;
          }
          
          .plan-price {
            font-size: 1.6rem !important;
          }
          
          .why-choose-title {
            font-size: 1.5rem !important;
          }
          
          .cta-section h2 {
            font-size: 1.4rem !important;
          }
          
          button {
            font-size: 0.9rem !important;
            padding: 12px 20px !important;
          }
        }
      `}</style>
      {/* Header Section */}
      <section className="consultation-header" style={{ 
        padding: '80px 0 60px 0', 
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 style={{ 
            fontSize: '3rem', 
            fontWeight: 'bold', 
            marginBottom: '20px' 
          }}>
            Student Consultation Services
          </h1>
          <p style={{ 
            fontSize: '1.2rem', 
            maxWidth: '700px', 
            margin: '0 auto',
            opacity: '0.9',
            lineHeight: '1.6'
          }}>
            Get expert guidance for your German study journey. From visa applications to university admissions, 
            we're here to help you succeed in Germany.
          </p>
        </div>
      </section>

      {/* Plans Section */}
      <section className="plans-section" style={{ padding: '80px 0', backgroundColor: '#f8f9fa' }}>
        <div className="container">
          <div className="plans-grid" style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', 
            gap: '30px',
            maxWidth: '1400px',
            margin: '0 auto'
          }}>
            {plans.map((plan) => (
              <div
                key={plan.id}
                className="plan-card"
                style={{
                  backgroundColor: 'white',
                  borderRadius: '16px',
                  padding: '40px 30px',
                  boxShadow: plan.popular 
                    ? '0 10px 40px rgba(102, 126, 234, 0.15)' 
                    : '0 4px 20px rgba(0, 0, 0, 0.08)',
                  border: plan.popular ? '2px solid #667eea' : '1px solid #e2e8f0',
                  position: 'relative',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = plan.popular 
                    ? '0 15px 50px rgba(102, 126, 234, 0.2)' 
                    : '0 8px 30px rgba(0, 0, 0, 0.12)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = plan.popular 
                    ? '0 10px 40px rgba(102, 126, 234, 0.15)' 
                    : '0 4px 20px rgba(0, 0, 0, 0.08)';
                }}
              >
                {plan.popular && (
                  <div style={{
                    position: 'absolute',
                    top: '-10px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: '#667eea',
                    color: 'white',
                    padding: '5px 20px',
                    borderRadius: '20px',
                    fontSize: '0.9rem',
                    fontWeight: 'bold'
                  }}>
                    Most Popular
                  </div>
                )}

                <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                  <h3 className="plan-title" style={{ 
                    fontSize: '1.5rem', 
                    fontWeight: 'bold', 
                    color: '#333',
                    marginBottom: '10px'
                  }}>
                    {plan.title}
                  </h3>
                  
                  <div style={{ marginBottom: '10px' }}>
                    <span className="plan-price" style={{ 
                      fontSize: '2.5rem', 
                      fontWeight: 'bold', 
                      color: plan.popular ? '#667eea' : '#333'
                    }}>
                      {plan.price}
                    </span>
                  </div>
                  
                  <p style={{ 
                    color: '#666', 
                    fontSize: '1rem',
                    margin: '0'
                  }}>
                    {plan.duration}
                  </p>
                </div>

                <ul className="plan-features" style={{ 
                  listStyle: 'none', 
                  padding: '0', 
                  marginBottom: '30px' 
                }}>
                  {plan.features.map((feature, index) => (
                    <li key={index} className="plan-feature" style={{ 
                      display: 'flex', 
                      alignItems: 'flex-start',
                      marginBottom: '12px',
                      fontSize: '0.95rem',
                      lineHeight: '1.4'
                    }}>
                      <span style={{ 
                        color: '#4CAF50', 
                        marginRight: '10px',
                        fontSize: '1.2rem',
                        minWidth: '20px'
                      }}>
                        ✓
                      </span>
                      <span style={{ color: '#555' }}>{feature}</span>
                    </li>
                  ))}
                </ul>

                <button
                  onClick={() => handleBookConsultation(plan.title)}
                  style={{
                    width: '100%',
                    padding: '14px 20px',
                    backgroundColor: plan.popular ? '#667eea' : '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = plan.popular ? '#5a67d8' : '#45a049';
                    e.target.style.transform = 'translateY(-1px)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = plan.popular ? '#667eea' : '#4CAF50';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  Book Now
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-section" style={{ padding: '80px 0', backgroundColor: 'white' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2 className="why-choose-title" style={{ 
              fontSize: '2.5rem', 
              fontWeight: 'bold', 
              color: '#333',
              marginBottom: '20px'
            }}>
              Why Choose Our Consultation Services?
            </h2>
            <p style={{ 
              fontSize: '1.1rem', 
              color: '#666',
              maxWidth: '600px',
              margin: '0 auto',
              lineHeight: '1.6'
            }}>
              We have helped thousands of students successfully navigate their German education journey.
            </p>
          </div>

          <div className="why-choose-grid" style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
            gap: '40px' 
          }}>
            <div className="feature-card" style={{ textAlign: 'center' }}>
              <div style={{
                width: '80px',
                height: '80px',
                backgroundColor: 'rgba(102, 126, 234, 0.1)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px auto'
              }}>
                <span style={{ fontSize: '2.5rem' }}>🎓</span>
              </div>
              <h3 className="feature-title" style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#333', marginBottom: '15px' }}>
                Expert Guidance
              </h3>
              <p className="feature-text" style={{ color: '#666', lineHeight: '1.6' }}>
                Our consultants have years of experience helping international students succeed in Germany.
              </p>
            </div>

            <div className="feature-card" style={{ textAlign: 'center' }}>
              <div style={{
                width: '80px',
                height: '80px',
                backgroundColor: 'rgba(76, 175, 80, 0.1)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px auto'
              }}>
                <span style={{ fontSize: '2.5rem' }}>📋</span>
              </div>
              <h3 className="feature-title" style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#333', marginBottom: '15px' }}>
                Personalized Plans
              </h3>
              <p className="feature-text" style={{ color: '#666', lineHeight: '1.6' }}>
                Every consultation is tailored to your specific needs, goals, and academic background.
              </p>
            </div>

            <div className="feature-card" style={{ textAlign: 'center' }}>
              <div style={{
                width: '80px',
                height: '80px',
                backgroundColor: 'rgba(255, 193, 7, 0.1)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px auto'
              }}>
                <span style={{ fontSize: '2.5rem' }}>🤝</span>
              </div>
              <h3 className="feature-title" style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#333', marginBottom: '15px' }}>
                Ongoing Support
              </h3>
              <p className="feature-text" style={{ color: '#666', lineHeight: '1.6' }}>
                We don't just consult once - we provide continued support throughout your journey.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="cta-section" style={{ 
        padding: '60px 0',
        backgroundColor: '#667eea',
        color: 'white',
        textAlign: 'center'
      }}>
        <div className="container">
          <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '20px' }}>
            Ready to Start Your German Journey?
          </h2>
          <p style={{ fontSize: '1.1rem', marginBottom: '30px', opacity: '0.9' }}>
            Book a consultation today and take the first step towards studying in Germany.
          </p>
          <button
            onClick={() => console.log('Contact for more info')}
            style={{
              backgroundColor: 'white',
              color: '#667eea',
              padding: '15px 30px',
              border: 'none',
              borderRadius: '8px',
              fontSize: '1.1rem',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 8px 25px rgba(255, 255, 255, 0.3)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            Contact Us for More Information
          </button>
        </div>
      </section>
    </div>
  );
};

export default Consultation;
